<p-messages [enableService]="true" [closable]="false"></p-messages>

<div class="row">
	<div class="col-sm-12">
		<form [formGroup]="form">
			<div class="br-card bg-gray-2">
				<div class="card-content">
					<div class="row">
						<div class="col-sm-12 br-input" [ngClass]="{'danger': form.controls['idConcurso'].errors?.required && submetido}">
							<label for="campo-concurso">Concurso:</label>
							<p-autoComplete
								#autoCompleteObject
								id="selecaoConcurso"
								formControlName="idConcurso"
								[suggestions]="filteredConcursos"
								(completeMethod)="filtrarConcursos($event)"
								optionLabel="label"
								optionValue="value"
								dropdownAriaLabel="concurso"
								[minLength]="3"
								[dropdown]="true"
								[attr.required]="true"
								[forceSelection]="true"
								[placeholder]="placeholderConcurso"
								[showEmptyMessage]="true"
								emptyMessage="Nenhuma opção encontrada"
								(onSelect)="selecionarConcurso($event)"
								(onClear)="selecionarConcurso($event)"
							></p-autoComplete>
						</div>
					</div>
					<div class="row">
						<div class="col-sm-12 mt-2 br-input">
							<label for="campo-orgao">Órgão:</label>
							<p-autoComplete
								#autoCompleteObject
								id="campo-orgao"
								formControlName="codigoOrgao"
								[suggestions]="filteredOrgaos"
								(completeMethod)="filtrarOrgaos($event)"
								optionLabel="name"
								optionValue="code"
								dropdownAriaLabel="orgao"
								[minLength]="3"
								[dropdown]="true"
								[attr.required]="true"
								[forceSelection]="true"
								[placeholder]="placeholderOrgao"
								[showEmptyMessage]="true"
								emptyMessage="Nenhuma opção encontrada"
								(onSelect)="selecionarOrgao($event)"
								(onClear)="selecionarOrgao($event)"
								data-cy="campo-orgao"
							></p-autoComplete>
						</div>
					</div>
					<div class="row">
						<div class="col-sm-8 mt-2 br-input">
							<label for="campo-cargo">Cargo:</label>
							<input
								#elTextoPesquisa
								name="campo-cargo"
								pInputText
								type="text"
								data-cy="campo-cargo"
								formControlName="nomeCargo"
								[ngModelOptions]="{standalone: true}"
								maxlength="140"
								[placeholder]="placeholderCargo"
							/>
						</div>
						<div class="col-sm-4 mt-2 br-input">
							<label for="campo-codigo-cargo">Código do cargo:</label>
							<input
								onlyNumbers
								id="campo-codigo-cargo"
								type="text"
								formControlName="codigoCargoStr"
								maxlength="6"
								(blur)="formatarCodigoCargo()"
								inputmode="numeric"
								pattern="[0-9]*"
								data-cy="campo-codigo-cargo"
								placeholder="Informe o código do cargo"
							/>
						</div>
					</div>
					<div class="row">
						<div class="col-sm-6 mt-2 br-input">
							<label for="campo-situacao">Situação do questionário / cargo:</label>
							<p-dropdown
								[options]="(cargoApiService.situacoes$ | async)!"
								formControlName="situacao"
								(onChange)="reiniciarPaginacao()"
								placeholder="Selecione"
								[showClear]="true"
								optionLabel="descricao"
								optionValue="codigo"
								id="campo-situacao"
								data-cy="campo-situacao"
							></p-dropdown>
						</div>
						<div class="col-sm-6 mt-2 br-input" *ngIf="concursoSelecionado?.utiliza_perfil">
							<label for="campo-periodo-envio">Período de liberação:</label>
							<sgp-texto-ajuda
								texto="Este campo se aplica a concursos que utilizam o perfil profissiográfico e se refere ao período em que o questionário está disponível para ser respondido pelo(as) candidato(as)."
							/>
							<p-calendar
								[showIcon]="true"
								formControlName="periodo"
								selectionMode="range"
								[readonlyInput]="false"
								(ngModelChange)="reiniciarPaginacao()"
								inputId="campo-periodo-liberacao"
								dateFormat="dd/mm/yy"
								rangeSeparator=" até "
								placeholder="Período em que o questionário estará liberado para respostas do candidato."
								data-cy="campo-periodo-liberacao"
								[style]="{'minWidth':'350px'}"
								[inputStyle]="{'margin':'0px !important'}"
							>
							</p-calendar>
							<sgp-message-feedback
								[show]="form.controls['periodo'].errors?.['dataFinalDePeriodoFaltando'] && submetido"
								mensagem="Preencha as duas datas do período"
								data-cy="erro-concurso-obrigatorio"
							></sgp-message-feedback>
						</div>
					</div>
				</div>
				<div class="card-footer">
					<div class="row mt-4">
						<div class="col text-right">
							<button pButton data-cy="btnClear" class="secondary mr-2" (click)="limpar()">Limpar</button>
							<button pButton type="submit" data-cy="btnSubmit" class="primary" (click)="pesquisar()">Pesquisar</button>
						</div>
					</div>
				</div>
			</div>
		</form>
	</div>
</div>
